import AppListing from '../app-components/Listing/AppListing';

Vue.component('app-payment-listing', {
    mixins: [AppListing],
    props:{
        factories: {
            type: Array,
            default: []
        },
        factories: {
            type: Array,
            default: []
        },
        appOfficesId:null,
        offices: {
            type: Array,
            default: ()=>[]
        },
        listFields: {
            type: Array,
            default: ()=>[]
        },
    },
    data: function () {  
        return {
            showFilter: false,
            moduleFilters:{
                date_start: null,
                date_end: null,
                weight_date_start: null,
                weight_date_end: null,
                app_factories_id: null,
                app_offices_id: null,
                payment_status: null,
                app_fields_id: null,
            },
            tempWeightdate: null,
            tempFactory: null,
            tempField: null,
            tempOffice: null,
            paymentStatus: null,
            orderBy: {
                column: 'app_payments.created_at',
                direction: 'desc'
            },
        }
    },
    methods:{
        onChangeWeightDateRangeFilter(dateRange){
            if (dateRange) {
                if (dateRange[0] && dateRange[1]) {
                    const startDate = moment(dateRange[0]).startOf('day')
                    const endDate = moment(dateRange[1]).endOf('day')
                    this.moduleFilters.weight_date_start = this.getDateFromString(startDate, null, this.dateFormat.ymdhis, 'utc') 
                    this.moduleFilters.weight_date_end = this.getDateFromString(endDate, null, this.dateFormat.ymdhis, 'utc') 
                }else{
                    this.moduleFilters.weight_date_start =  null
                    this.moduleFilters.weight_date_end = null
                }
            }else{
                this.moduleFilters.weight_date_start =  null
                this.moduleFilters.weight_date_end = null
            }

            this.applyFilters()
        },
        getFileName(){
            return this.getListingFileName('daftar_pembayaran_from')
        },
        onSelectFactory (factory) { 
            this.tempFactory = factory
            this.moduleFilters.app_factories_id = (factory==null)? null: factory.id
            this.applyFilters()
        },
        onSelectField (Field) { 
            this.tempField = Field
            this.moduleFilters.app_fields_id = (Field==null)? null: Field.id
            this.applyFilters()
        },
        onSelectOffice (Office) { 
            this.tempOffice = Office
            this.moduleFilters.app_offices_id = (Office==null)? null: Office.id
            this.applyFilters()
        },
        onUpdatePaymentStatus(item){
            console.log('item', item)
            this.moduleFilters.payment_status=item.id
            this.applyFilters()
        },
        onRemovePaymentStatus(){
            this.moduleFilters.payment_status=null
            this.applyFilters()
        },
    }
});